import { Translation } from '@ps/web-shared-components';
import React from 'react';

import type { MultiPurposeNotification } from '@swf/core/types/Notification';

import type { CardTranslationTag } from '../../config/NotificationTypes';
import { geti18NValueConfig } from '../../utils';

import styles from './Title.scss';

interface Props {
  title?: string;
  titleKey: CardTranslationTag;
  attributes: MultiPurposeNotification['attributes'];
}

const Title: React.FC<Props> = ({ title, titleKey, attributes }) => (
  <h1 className={styles.title}>
    {title && <span>{title}</span>}
    {!title && titleKey.tag && (
      <Translation {...titleKey.tag} values={geti18NValueConfig(titleKey.values, attributes)} />
    )}
  </h1>
);

export default Title;
